angular.module('leanlaw').controller('MatterActivityCtrl', ['$scope', '$state', '$filter', 'userService', "exportJson", "reportsService", "messageBus", 'singleRequest', function ($scope, $state, $filter, userService, exportJson, reportsService, messageBus, singleRequest) {
  $scope.data = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filtered.map(m => ({
      [`${matter} ID`]: m.reference ? !isNaN(m.reference) ? `="${m.reference}"` : m.reference : '',
      [matter]: m.name,
      'Client ID': m.client.reference,
      'Client': m.client.name,
      'Responsible': m.primary.initials || m.primary.name,
      'Opened': $filter('dateLogical')(m.opened),
      'Archived': m.active ? '-' : $filter('dateLogical')(m.updated),
      'Last Activity': $filter('dateLogical')(m.updated)
    }));
    exportJson.downloadCsv(exp);
  };
  $scope.openMatter = matter => {
    return $state.go('matters-next.client.matter', {
      id: matter.client.id,
      matterId: matter.id
    });
  };
  activate();

  ///////////////////

  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      $scope.$on('commonFilterService-statechanged', (event, payload) => {
        if (!payload) return;
        // Assigning to existing filter keeps custom filter options
        $scope.filter = Object.assign($scope.filter, payload);
        // Necessary to set this value for the requests
        $scope.filter.status = $scope.filter.archived.status;
        $scope.filter.scope = $scope.filter.filter.scope;
        $scope.filter.dateFilter = $scope.filter.dateFilter || {
          id: 'all'
        };
        $scope.filter.dateRange = $scope.filter.dateRange || {
          startDate: null,
          endDate: null
        };
        loadEntries().then(() => {
          filterEntries();
        });
      });
      $scope.$on("report-sidebar-filterchange", (event, payload) => {
        $scope.filter = Object.assign($scope.filter, payload);
        filterEntries();
      });

      // MessageBus is used here so that the commonFilter module can pick it up once it loads
      messageBus.addMessage("filterDependency-ready", true);
    });
  }
  function loadEntries() {
    $scope.loading = true;
    const query = reportsService.queryFromFilter($scope.filter);
    return singleRequest.apiCall("matterList").listMatters(query).then(data => {
      if (data) {
        loadMatters(data.matters);
      }
    });
  }
  $scope.filterTimePeriod = (timePeriod, id) => {
    return function (matter) {
      if (!(timePeriod && timePeriod.dateRange && timePeriod.dateRange.startDate)) return matter;
      if (id === 'all') return matter;
      if (id === 'active') return matter.active && dateMatch(matter.updated, timePeriod.dateRange);
      if (id === 'opened') return dateMatch(matter.opened, timePeriod.dateRange);
      if (id === 'closed') return !matter.active && dateMatch(matter.updated, timePeriod.dateRange);
      return dateMatch(matter.updated, timePeriod.dateRange);
    };
  };
  function loadMatters(matters) {
    $scope.loading = false;
    $scope.matterReferences = !!matters.find(m => m.reference);
    $scope.clientReferences = !!matters.find(m => m.client.reference);
    $scope.matters = matters;
  }
  const dateFilters = {
    'all': () => true,
    'active': m => m.active,
    'opened': (m, dateRange) => dateMatch(m.opened, dateRange),
    'closed': (m, dateRange) => !m.active && dateMatch(m.updated, dateRange),
    'activity': (m, dateRange) => dateMatch(m.updated, dateRange)
  };
  function dateMatch(dateString, dateRange) {
    const date = new Date(dateString);
    if (dateRange.startDate && dateRange.startDate > date) {
      return false;
    }
    if (dateRange.endDate && dateRange.endDate < date) {
      return false;
    }
    return true;
  }
  function filterEntries() {
    const {
      dateRange
    } = $scope.filter;
    const current = dateFilters[$scope.filter.dateFilter.id];
    if ($scope.matters) $scope.data.filtered = $scope.matters.filter(m => current(m, dateRange));
  }

  // The rows the table shows. Precomputed here rather than built in the ng-repeat
  // expression, which rebuilt the time-period predicate and re-sorted every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    const period = $scope.filterTimePeriod($scope.filter.dateRange, $scope.filter.dateFilter && $scope.filter.dateFilter.id);
    const matching = $filter('filter')($scope.data.filtered, period);
    $scope.data.filteredMatters = $filter('orderBy')(matching, $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.filtered', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse', 'filter.dateRange', 'filter.dateFilter.id'], updateFiltered);
}]);